import Joi from 'joi';

export const leaseMeteringObserveSchema = () =>
  Joi.object({
    leasedBy: Joi.string().required(),
    leasedUntil: Joi.date().required(),
    batch: Joi.number().integer().positive().required(),
  }).unknown();

export const leaseMeteringApplySchema = () =>
  Joi.object({
    leasedBy: Joi.string().required(),
    leasedUntil: Joi.date().required(),
    batch: Joi.number().integer().positive().required(),
  }).unknown();

export const writeMeteringObservationsSchema = () =>
  Joi.object({
    records: Joi.array()
      .items(
        Joi.object({
          tenantId: Joi.number().integer().positive().required(),
          incomplete: Joi.boolean().optional(),
          observedHash: Joi.string().length(64).allow(null).optional(),
          observedState: Joi.object().unknown(true).allow(null).optional(),
        }),
      )
      .min(1)
      .required(),
  }).unknown();

export const markMeteringDirtySchema = () =>
  Joi.object({
    tenantIds: Joi.array().items(Joi.number().integer().positive()).optional(),
    meteringProviderCustomerIds: Joi.array().items(Joi.string()).optional(),
  })
    .or('tenantIds', 'meteringProviderCustomerIds')
    .unknown();

export const releaseMeteringApplySchema = () =>
  Joi.object({
    records: Joi.array()
      .items(
        Joi.object({
          tenantId: Joi.number().integer().positive().required(),
          success: Joi.boolean().required(),
          appliedHash: Joi.string().length(64).allow(null).optional(),
        }),
      )
      .min(1)
      .required(),
  }).unknown();

export const driftSweepMeteringSchema = () =>
  Joi.object({
    batch: Joi.number().integer().positive().required(),
  }).unknown();

export const entitlementSyncFailureUpsertSchema = () =>
  Joi.object({
    fingerprint: Joi.string().max(128).required(),
    tenantId: Joi.number().integer().positive().allow(null).optional(),
    meteringProviderCustomerId: Joi.string().max(128).allow(null).optional(),
    code: Joi.string().max(64).required(),
    failureClass: Joi.string().valid('permanent', 'transient').required(),
    message: Joi.string().max(2048).required(),
    details: Joi.object().unknown(true).allow(null).optional(),
  }).unknown();

export const resolveEntitlementSyncFailuresSchema = () =>
  Joi.object({
    fingerprints: Joi.array().items(Joi.string().max(128)).optional(),
    tenantId: Joi.number().integer().positive().allow(null).optional(),
  })
    .or('fingerprints', 'tenantId')
    .unknown();

export const invalidateMeteringAppliedSchema = () =>
  Joi.object({
    tenantIds: Joi.array()
      .items(Joi.number().integer().positive())
      .min(1)
      .required(),
  }).unknown();
